import { LayersIcon, ZapIcon, BookOpenIcon } from 'lucide-react';

export const apparatusList = ['Suelo', 'Reformer', 'Cadillac', 'Silla', 'Accesorios', 'Pared'];

export const benefitBadges = [
  {
    icon: BookOpenIcon,
    title: '515 páginas de contenido',
    text: '240 fichas de ejercicios, preparaciones y variantes en 6 tomos.'
  },
  {
    icon: LayersIcon,
    title: 'Progresión adaptada',
    text: 'Opciones para simplificar y progresar según el control observado en cada alumna.'
  },
  {
    icon: ZapIcon,
    title: 'Preparación guiada',
    text: 'Consulta la secuencia, prepara el material y adapta las tareas a tu alumnado.'
  }
];
